import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { useTranslation } from 'react-i18next';

export default function ContactPage() {
  const { t } = useTranslation();
  useEffect(() => {
    const d = document;
    const w = "https://tally.so/widgets/embed.js";
    const v = function() {
      // @ts-ignore
      if (typeof Tally !== "undefined") {
        // @ts-ignore
        Tally.loadEmbeds();
      } else {
        d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach(function(e) {
          // @ts-ignore
          e.src = e.dataset.tallySrc;
        });
      }
    };

    // @ts-ignore
    if (typeof Tally !== "undefined") {
      v();
    } else if (d.querySelector('script[src="' + w + '"]') == null) {
      const s = d.createElement("script");
      s.src = w;
      s.onload = v;
      s.onerror = v;
      d.body.appendChild(s);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navbar />
      
      <section className="relative min-h-[70vh] flex flex-col justify-center overflow-hidden bg-white pt-32 pb-20">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-[80vw] h-[80vw] border border-gray-100 rounded-full absolute"></div>
          <div className="w-[60vw] h-[60vw] border border-gray-100 rounded-full absolute"></div>
        </div>
        
        <div className="relative z-20 w-full max-w-7xl mx-auto px-2 md:px-10">
          <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
            {t('contact.subtitle')}
          </span>
          <h1 className="font-display text-[12vw] leading-none font-bold text-gray-900 uppercase tracking-tighter mt-12">
            {t('contact.title')}<br />
            <span className="text-gray-300 italic">{t('contact.highlight')}</span>
          </h1>
        </div>
      </section>
      
      <section className="py-20 px-2 md:px-10 border-t border-gray-50">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-20">
          <div className="lg:col-span-5">
            <p className="font-sans text-xl text-gray-500 leading-relaxed mb-12">
              {t('contact.description')}
            </p>
          </div>

          <div className="lg:col-span-7">
            <iframe 
              data-tally-src="https://tally.so/embed/Bzd6Le?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" 
              loading="lazy" 
              width="100%" 
              height="276" 
              frameBorder="0" 
              title="null"
              className="w-full"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer withCTA={false} />
    </div>
  );
}
